module.exports = __webpack_public_path__ + "img/wasl.fb15a0d8.jpg";